var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":_vm.seleccionar}},[_vm._v(" "+_vm._s(_vm.opcion == 0 ? "N/A" : _vm.opcion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }